import { useAuthToggles } from "./useAuthToggles";

export const useEnableSankhyaMenu = authUrl => {
  const { data, isLoading } = useAuthToggles(authUrl);

  return {
    enableSankhyaMenu: data?.enable_sankhya_menu ?? false,
    isLoading
  };
};
